import axios from 'axios';
import Handlers from './handlers'

class SchedulerService {
	filterTasks(requestData = {}) {
        return new Promise((resolve, reject) => {
            const url =  '/tasks/filter';
            axios.get(url, { params: requestData })
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    createQuickTask({data}) {
        const url =  `/work-processes/create-quick-task`;
        return new Promise((resolve, reject) => {
            axios.post(url, data)
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    updateTask({workProcessId, taskId, data}) {
        const url =  `/work-processes/${workProcessId}/tasks/${taskId}`;
        return new Promise((resolve, reject) => {
            axios.put(url, data)
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    postponeTask(taskId, days) {
        const url =  `/tasks/${taskId}/postpone`;
        return new Promise((resolve, reject) => {
            axios.post(url, { days })
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    postponeWorkProcess(workProcessId, days) {
        const url =  `/work-processes/${workProcessId}/postpone`;
        return new Promise((resolve, reject) => {
            axios.post(url, { days })
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    removeTaskFromCalendar(taskId) {
        const url =  `/tasks/${taskId}/remove-from-calendar`;
        return new Promise((resolve, reject) => {
            axios.post(url)
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    removeProcessFromCalendar(workProcessId) {
        const url =  `/work-processes/${workProcessId}/remove-from-calendar`;
        return new Promise((resolve, reject) => {
            axios.post(url)
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
    getTimesheetForPeriod(requestData = {}) {
        return new Promise((resolve, reject) => {
            const url =  '/working-time-setups/get_timesheet';
            axios.post(url, requestData)
                .then(response => {
                    Handlers.SUCCESS_HANDLER(url, response.data, null, resolve);
                })
                .catch(error => {
                    Handlers.ERROR_HANDLER(url, error, null, reject);
                });
        });
    }
}

export default new SchedulerService();